import Vue from 'vue';
import {
  getReservation, updateReservation
 } from '../../../services/crmService/reservationService';

import {
  getReservationTimeList, getReservationTypeList, storeLorealReservation
} from '../../../services/personnelService/reservationService';

 // initial state
 // state 必為模組區域變數，取時需 store.state.auth.user
 // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
 // 區域使用時值需加上 name
const state = {
  reservations: [],
  pagination: {
    current_page: 0,
    per_page: 5
  },
  reservationsTypeList: [],
  reservationTimeList: [],
  store: ''
};

 // getters
 const getters = {};

 // actions
const actions = {
  // 取得預約列表
  async getReservationHandler({ commit }, statusInfo) {
    const data = await getReservation(statusInfo);
    commit('setReservations', data);
  },
  // 取得預約種類
  async getReservationTypeListHandler({ commit }) {
    const data = await getReservationTypeList();
    commit('setReservationsTypeList', data.data);
  },
  // 拿取可預約時間列表
  async getReservationTimeListHandler({ commit }, formData) {
    const data = await getReservationTimeList(formData);
    commit('setReservationTimeList', data.data);
  },
  // 修改預約
  async updateReservationHandler({}, updateInfo) {
    await updateReservation(updateInfo);
  },
  // 送出預約
  async storeLorealReservationHandler({}, storeInfo) {
    const { data } = await storeLorealReservation(storeInfo);
    return data;
  }
};

// mutations
const mutations = {
  setReservations(state, data) {
    Vue.set(state, 'reservations', state.reservations.concat(data.data.reservations));
    Vue.set(state, 'pagination', data.pagination);
  },
  setReservationsTypeList(state, data) {
    Vue.set(state, 'reservationsTypeList', data['reservation-campaign-list']);
    Vue.set(state, 'store', data.store);
  },
  // 重置所有資料
  resetHandler(state) {
    Vue.set(state, 'reservations', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 5
    });
  },
  setReservationTimeList(state, data) {
    Vue.set(state, 'reservationTimeList', Object.values(data['reservation-period-list']));
  },
  resetReservationTimeList(state) {
    Vue.set(state, 'reservationTimeList', []);
  }
};

 export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
 };
